import React from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import Logo from '../common/logo'
import Seo from '../common/seo'
import Social from '../common/social'

export type PageProps = {
    name: string
    transparent?: boolean
    hideSocial?: boolean
    hideHeader?: boolean
    shade?: boolean // For service pages to make bg gray
    centerLogo?: boolean
    invertedLogo?: boolean
    hideBg?: boolean
    consistentBg?: boolean // true means on mobile we also set bg
    bgColor?: string
}

const Page: React.FunctionComponent<PageProps> = ({ hideSocial, hideHeader, shade, name, centerLogo, invertedLogo, children, hideBg, consistentBg, bgColor }) => (
    <Container shade={shade} hideBg={hideBg} consistentBg={consistentBg} bgColor={bgColor}>
        <Seo pageName={name} />
        { !hideHeader && <Header centerLogo={centerLogo}>
            <Logo inverted={invertedLogo} />
            { !hideSocial && <Social /> }
        </Header> }
        {children}
    </Container>
)

const Container = styled.div<{ shade?: boolean, hideBg?: boolean, consistentBg?: boolean, bgColor?: string }>`
    display: grid;
    grid-template-rows: 1fr auto;
    
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;

    position: relative;

    background: ${
        p => p.bgColor
            ? p.bgColor
            : p.consistentBg
                ? p.hideBg
                    ? 'none'
                    : p.shade 
                        ? p.theme.colors.bgService 
                        : p.theme.colors.bg
                : p.theme.colors.bg
    };

    ${up('tablet')} {
        background: ${p => p.bgColor
            ? p.bgColor
            : p.hideBg 
                ? 'none'
                : p.shade ? p.theme.colors.bgService : p.theme.colors.bg
        };
    }
`

const Header = styled.div<{centerLogo?: boolean}>`
    position: absolute;

    color: ${p => p.theme.colors.bg};
    font-size: 20px;
    padding: 8px 20px;

    height: 60px;
    width: 100%;
    display: flex;
    justify-content: ${p => p.centerLogo ? 'center' : 'space-between'};
    align-items: center;

    z-index: 10;

    ${up('mobileBig')} {
        height: 80px;
        padding: 18px 20px;
    }

    ${up('tablet')} {
        padding: 18px 32px;
    }

    ${up('desktop')} {
        padding: 18px 80px;
    }
`

export default Page